import React, {ReactElement} from 'react'
import {PermissionsMap} from '@/stores/auth/constants/permissions-map'
import OverviewOnlinePaymentsAnalytics from '@/pages/Overview/components/OverviewOnlinePaymentsAnalytics/OverviewOnlinePaymentsAnalytics'
import OverviewPosPaymentsAnalytics from '@/pages/Overview/components/OverviewPosPaymentsAnalytics/OverviewPosPaymentsAnalytics'

export const OverviewTabsContainerStoreSymbol = Symbol('OverviewTabsContainerStore')
export const EcomOverviewRangePickerStoreSymbol = Symbol('EcomOverviewRangePickerStore')
export const PosOverviewRangePickerStoreSymbol = Symbol('PosOverviewRangePickerStore')
export const OverviewECOMCurrencySelectStoreSymbol = Symbol('OverviewECOMCurrencySelectStore')
export const OverviewPOSCurrencySelectStoreSymbol = Symbol('OverviewPOSCurrencySelectStore')
export const OverviewEcomStoreSelectStoreSymbol = Symbol('OverviewEcomStoreSelectStore')
export const OverviewPosStoreSelectStoreSymbol = Symbol('OverviewPosStoreSelectStore')

export const OverviewEcomTransactionsStatusStoreSymbol = Symbol(
    'OverviewEcomTransactionsStatusStore'
)

export const currencySelectStoreMapOriginal: Record<string, symbol> = {
    onlinePayments: OverviewECOMCurrencySelectStoreSymbol,
    posPayments: OverviewPOSCurrencySelectStoreSymbol
}

export const rangePickerConfigMapOriginal: Record<
    string,
    {
        key: string
        injectableIdentifier: symbol
    }
> = {
    onlinePayments: {
        key: 'onlinePayments',
        injectableIdentifier: EcomOverviewRangePickerStoreSymbol
    },
    posPayments: {
        key: 'posPayments',
        injectableIdentifier: PosOverviewRangePickerStoreSymbol
    }
}

export const analyticsConfigMapOriginal: Record<
    string,
    {
        permissions: string[]
        component: ReactElement
    }
> = {
    onlinePayments: {
        permissions: [PermissionsMap.online_payments.read, PermissionsMap.online_payments.full],
        component: <OverviewOnlinePaymentsAnalytics />
    },
    posPayments: {
        permissions: [PermissionsMap.pos_payments.read, PermissionsMap.pos_payments.full],
        component: <OverviewPosPaymentsAnalytics />
    }
}


